var Backbone = require('backbone');
var _ = require('underscore');
var svg4everybody = require('svg4everybody');
var FontFaceObserver = require('fontfaceobserver');
//var FastClick = require('fastclick/lib/fastclick.js');


//Backend urls chhemas to generate them on frontend
window.Urls = require('reverse.js').Urls;
window.UrlsAvailability = require('django_js_availability/reverse.js').Urls;

//to be on top of all styles
//to left other styles chance to override it without !important and other magic
require('front/text.less');

var Settings = require('./Settings');
var Router = require('./Router');
var Utils = require('front/utils/Utils.js');

require('front/components/Content/Content');

var Footer = require('front/components/Footer/Footer');
var TopNav = require('front/components/TopNav/TopNav');
var TopNavPopup = require('front/components/TopNav/TopNavPopup');

require('velocity-animate/velocity.min.js');
require('velocity-animate/velocity.ui.min.js');
require('reset.css');
require('front/style.less');
require('front/utils.less');
require('front/fonts.less');
require('mq.genie-0.5.0.js');

//fix for hovers|active on mobile, what a weird behavior!
//fastclick solves this problem, but adds a bunch of other
if (!app.settings.isDesktop) {
    $('body *').on('touchstart', function () {});
}


app.shareFacebook = function (data) {
    window.open(
        'https://www.facebook.com/sharer/sharer.php?u=' + encodeURIComponent(data.link),
        'facebooksharedialog',
        'width=626,height=436');
};


app.shareTwitter = function (data) {
    var tweetUrl = 'https://twitter.com/share' +
        '?url=' + encodeURIComponent(data.link) +
        '&text=' + encodeURIComponent(data.title);

    window.open(tweetUrl, '', 'menubar=no,toolbar=no,resizable=yes,scrollbars=yes,height=600,width=600');
};


app.shareMail = function (data) {
    window.location.href = 'mailto:?body=' + encodeURIComponent(data.title + ' — ' + data.link);
};


app.AdoptTempFileObject = function (responseText, dataType) {
    var parsedData = JSON.parse(responseText);
    var responseObject = {};

    if (dataType == 'image') {
        responseObject = {
            aspect: parsedData.aspect,
            width: parsedData.width,
            height: parsedData.height,
            tempImg: parsedData.url,
            tempImgId: parsedData.id
        };
    }

    if (dataType == 'file') {
        responseObject = {
            originalName: parsedData.originalName,
            mime: parsedData.mime[0],
            typ: parsedData.mime[0].split('/')[1],
            tempFile: parsedData.url,
            tempFileId: parsedData.id
        };
    }

    return responseObject;
};




import Promise from 'promise-polyfill';

if (!window.Promise) {
    window.Promise = Promise;
}


//Pervushinag закомментил, потому что в IE9-11 вместо того чтобы делать все хорошо, делает все плохо и все use внутри svg просто выпилпвает
//для случая когда свг с символами уже встроен в дум svg4everybody не только не нужен, но и вреден
//svg4everybody();



//turn it off, too buggy, 300ms lag can be eliminated in more simple way: css touch-action: manipulation;
// $(function () {
//     if (!app.settings.isDesktop) {
//         FastClick.attach(document.body);
//     }
// });

app.configure = Settings.configure;
app.configure();

window.app.vent = _.extend({}, Backbone.Events);

var futuraNormal = new FontFaceObserver('FuturaNormal');
var athelasNormal = new FontFaceObserver('AthelasNormal');

Promise.all([futuraNormal.load(), athelasNormal.load()]).then(function () {
    console.log('Fonts loaded');
    window.app.state.fontsLoaded = true;
    window.app.vent.trigger('fonts-loaded');
}, function () {
    console.log('Fonts is not available');
});

//if youtube api is ready before all we should trigger "youtube-ready"
//cause onYouTubePlayerAPIReady on base.jinja can't invoke it (no app.vent on that moment)
if (window.app.state.youtubePlayerAPIReady) {
    window.app.vent.trigger('youtube-ready');
}

//if youtube api is ready before all we should trigger "youtube-ready"
//cause onYouTubePlayerAPIReady on base.jinja can't invoke it (no app.vent on that moment)
if (window.app.state.googleMapsAPIReady) {
    window.app.vent.trigger('google-maps-ready');
}

window.app.utils = Utils;

window.app.els = {
    $window: $(window),
    $body: $('body'),
    $htmlBody: $('html,body'),
    $content: $('.Content'),
    $topNav: $('.TopNav'),
    $topNavPopup: $('.TopNavPopup')
};

window.app.isPhoneLayout = function () {
    return window.innerWidth < 768;
};


// $.get(window.app.settings.staticUrl + 'svg/front/symbol/svg/sprite.symbol.svg', function (data) {
$.get('/static/svg/front/symbol/svg/sprite.symbol.svg', function (data) {
    var div = document.createElement('div');
    div.style.display = 'none';
    div.innerHTML = new XMLSerializer().serializeToString(data.documentElement);
    document.body.insertBefore(div, document.body.childNodes[0]);
});

app.router = new Router();

app.els.$body.on('click', '.u-Route', function (e) {
    if (app.els.$body.hasClass('Page404')) {
        return;
    }

    var currentRoute = Backbone.history.getFragment();

    var parentUrl = $(e.target)
        .closest('a')
        .attr('href');

    var url = $(e.currentTarget).attr('href') || parentUrl;

    e.preventDefault();
    Backbone.history.navigate(url, {trigger: 'true'});
});


//should be first, cause topNav listen topNavPopup events
app.views = {
    topNavPopup: new TopNavPopup({
        el: $('.TopNavPopup')
    })
};

_.extend(app.views, {
    topNav: new TopNav({
        el: $('.TopNav')
    }),
    footer: new Footer({
        el: $('.Footer')
    })
});




$.fn.flashClass = function (className, delay) {
    var self = this;
    var timeout;
    this.addClass(className);
    clearTimeout(this.data('timeout'));
    timeout = setTimeout(function () {
        if (typeof self == 'object' && self.length) {
            self.removeClass(className);
            self.data('timeout', null);
        }
    }, delay);
    this.data('timeout', timeout);

    return this;
};


app.animateShowMoreSlideDown = function (params) {
    if (params.hasWrapper) {
        var $slideWrapper = params.$items.wrapInner('<div>').find('> div');
        var $sizeWrapper = params.$items;
    } else {
        var $slideWrapper = params.$items.wrapAll('<div>').parent();
        var $sizeWrapper = $slideWrapper.wrapAll('<div>').parent();
    }

    var height =  $slideWrapper.outerHeight(true);
    var speed = 2;//pixels per millisecond
    var duration = Math.round(height / speed);

    //fill needed space immidiately, to prevent glitches in animation due to layout recalculation on each step
    $sizeWrapper.css('height', height);

    $slideWrapper
        .hide()
        .slideDown(duration, function () {
            $sizeWrapper.css('height', '');
        });
};

app.animateWindowScroll = function (scrollTop) {
    app.state.preventMenuShowOnScroll = true;
    $('body, html').animate({'scrollTop': scrollTop}, 400);

    setTimeout(function () {
        app.state.preventMenuShowOnScroll = false;
    }, 500);
};


app.vent.on('make-logout', function () {
    this._xhr = $.ajax(Urls['member:api:logout'](), {
        method: 'GET',
        contentType: 'application/json; charset=utf-8',
        'success': function (data) {
            window.location.href = Urls['front:index']();
        }.bind(this),
        'error': function (data) {
            console.log(data);
        }.bind(this)
    });
});

//proceed any popup show/hide
//set all underlying content fixed position
app.vent.on('PopupShown', function () {
    var $items = [];
    var tops = [];
    var scrollTop = $(window).scrollTop();

    //first of all get top position of all elements that need to be fixed on popup shown
    $('.NeedFixOnPopup').each(function (id, item) {
        var $item = $(item);
        $items.push($item);
        tops.push($item.offset().top);
    });

    //after that set all items fixed position and position them at the very point there where they was
    _.each($items, function ($item, ind) {
        $item
            .css('top', tops[ind] - scrollTop)
            .addClass('FixedOnPopup');
    });

    app.state.popupShown = true;

    $(window).resize();
}.bind(this));

app.vent.on('PopupHidded', function () {
    $('.NeedFixOnPopup').each(function (id, item) {
        $(item)
            .css('top', '')
            .removeClass('FixedOnPopup');
    });

    app.state.popupShown = false;
    $(window).resize();
}.bind(this));

//category - empty or 'all', 'myadg'
app.composeSearchUrl = function (query, page, category) {
    return window.Urls['front:search']() + '?q=' + encodeURIComponent(query) + '&p=' + encodeURIComponent(page) + (!category || category == 'all' ? '' : '&c=' + encodeURIComponent(category));
};


//for touch support of sortable UI
//has no npm version and should be after jQuery UI init, bu before first use
//so put it right here
/*!
 * jQuery UI Touch Punch 0.2.3
 *
 * Copyright 2011–2014, Dave Furfero
 * Dual licensed under the MIT or GPL Version 2 licenses.
 *
 * Depends:
 *  jquery.ui.widget.js
 *  jquery.ui.mouse.js
 */
/*eslint-disable */
!function(a){function f(a,b){if(!(a.originalEvent.touches.length>1)){a.preventDefault();var c=a.originalEvent.changedTouches[0],d=document.createEvent("MouseEvents");d.initMouseEvent(b,!0,!0,window,1,c.screenX,c.screenY,c.clientX,c.clientY,!1,!1,!1,!1,0,null),a.target.dispatchEvent(d)}}if(a.support.touch="ontouchend"in document,a.support.touch){var e,b=a.ui.mouse.prototype,c=b._mouseInit,d=b._mouseDestroy;b._touchStart=function(a){var b=this;!e&&b._mouseCapture(a.originalEvent.changedTouches[0])&&(e=!0,b._touchMoved=!1,f(a,"mouseover"),f(a,"mousemove"),f(a,"mousedown"))},b._touchMove=function(a){e&&(this._touchMoved=!0,f(a,"mousemove"))},b._touchEnd=function(a){e&&(f(a,"mouseup"),f(a,"mouseout"),this._touchMoved||f(a,"click"),e=!1)},b._mouseInit=function(){var b=this;b.element.bind({touchstart:a.proxy(b,"_touchStart"),touchmove:a.proxy(b,"_touchMove"),touchend:a.proxy(b,"_touchEnd")}),c.call(b)},b._mouseDestroy=function(){var b=this;b.element.unbind({touchstart:a.proxy(b,"_touchStart"),touchmove:a.proxy(b,"_touchMove"),touchend:a.proxy(b,"_touchEnd")}),d.call(b)}}}(jQuery);



//commented, can use e.page.index, that has correct active index (but it works only if dots is enabled)
/**
 * TrueCurrent for Owl Carousel (right index for loop case)
 * @since 2.0.2
 */
// ;(function($, window, document, undefined) {
//     'use strict';

//     var TrueCurrent = function(carousel) {

//         var current    = 0;
//         var itemsCount = 0;

//         /**
//          * Reference to the core.
//          * @protected
//          * @type {Owl}
//          */
//         this._core = carousel;

//         /**
//          * The carousel element.
//          * @type {jQuery}
//          */
//         this.$element = this._core.$element;

//         /**
//          * The carousel true current index.
//          * @type {Number}
//          */
//         this._trueCurrent = 0;

//         /**
//          * Changed event handler.
//          * @protected
//          * @type {Object}
//          */
//         this._handlers = {
//             'changed.owl.carousel': $.proxy(function (e) {

//                 current = (e.item.index + 1) - e.relatedTarget._clones.length / 2;
//                 itemsCount = e.item.count;

//                 if (current > itemsCount || current == 0) {
//                     current = itemsCount - (current % itemsCount);
//                 }

//                 this._trueCurrent = current;
//                 e.item._trueCurrent = current;

//             }, this)
//         };

//         // register event handlers
//         this.$element.on(this._handlers);
//     };

//     /**
//      * Destroys the plugin.
//      * @protected
//      */
//     TrueCurrent.prototype.destroy = function() {
//         var handler, control, property, override;

//         for (handler in this._handlers) {
//             this.$element.off(handler, this._handlers[handler]);
//         }
//         for (control in this._controls) {
//             this._controls[control].remove();
//         }
//         for (override in this.overides) {
//             this._core[override] = this._overrides[override];
//         }
//         for (property in Object.getOwnPropertyNames(this)) {
//             typeof this[property] != 'function' && (this[property] = null);
//         }
//     };

//     $.fn.owlCarousel.Constructor.Plugins.TrueCurrent = TrueCurrent;

// })(window.Zepto || window.jQuery, window, document);


/*eslint-enable */



app.router.start();

if (app.preview) {
    Backbone.history.loadUrl(app.preview.split('#')[0]);
}



//////////////////
// WEBPACK FOOTER
// ./assets/app/front/App.js
// module id = 152
// module chunks = 0